import { Component, Input } from '@angular/core';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-practitioner-information-item',
  template: `
    <fl-bit
      class="PractitionerInformationItem"
      [flMarginBottom]="Margin.XXSMALL"
    >
      <fl-label [weight]="FontWeight.BOLD"> {{ itemLabel }}:&nbsp; </fl-label>
      <fl-text>
        {{ itemValue }}
      </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-practitioner-information-item.component.scss'],
})
export class UserProfilePractitionerInformationItemComponent {
  FontWeight = FontWeight;
  Margin = Margin;

  @Input() itemLabel: string;
  @Input() itemValue: string | undefined;
}
